export const SetLoader = value => {
    return {
      type: 'SET_LOADER',
      payload: value,
    }
  }
  